import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { colorsV2 } from "../../styles/colors";
import UserService from "../../services/user";
import acHealthLogo from "../../resources/images/logo.png";
import Loader from "react-loader-advanced";

import * as actionCreators from "../../actions/whiteLabelSettings";

const PasswordReset = (props) => {
  const [loading, setLoading] = useState(true);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  //Password Rules
  const [match, setMatch] = useState(false);
  const [length, setLength] = useState(false);
  const [lower, setLower] = useState(false);
  const [upper, setUpper] = useState(false);
  const [number, setNumber] = useState(false);
  const [special, setSpecial] = useState(false);
  const [repeat, setRepeat] = useState(true);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [showSuccess, setShowSuccess] = useState(false);

  const submit = () => {
    if (!buttonDisabled) {
      UserService()
        .setNewUserPassword(props.match.params.token, password)
        .then((resp) => {
          if (resp.isPasswordUpdated == true) {
            setShowSuccess(true);
            setTimeout(() => {
              props.history.push("/");
            }, 5000);
          } else {
            setError(resp.updateMessage);
          }
        });
    } else {
      alert("Please enter a password that meets all password requirements.");
    }
  };

  useEffect(() => {
    if (password === confirmPassword) {
      setMatch(true);
    } else {
      setMatch(false);
    }
    setLength(password.length >= 8);
    setLower(/[a-z]/.test(password));
    setUpper(/[A-Z]/.test(password));
    setNumber(/[0-9]/.test(password));
    let specialChars = /[`!@#$%^&*()_\-+=\[\]{};':"\\|,.<>\/?~ ]/;
    setSpecial(specialChars.test(password));
    setRepeat(!/(.)\1\1/.test(password));
    if (match && length && lower && upper && number && special && repeat) {
      setButtonDisabled(false);
    }
  }, [password, confirmPassword, match]);

  useEffect(() => {
    //this is on a timeout to let the rehydrate call finish. I hate this but not sure what else to do at the moment?
    setTimeout(() => {
      setLoading(false);
      if (props.match.params.appCode !== null) {
        try {
          const appCode = props.match.params.appCode.toLowerCase();
          //Grab app Code and load white label settings
          if (appCode === "gl") {
            props.getWhiteLabelSettingsForApp(1);
          } else if (appCode === "rc") {
            props.getWhiteLabelSettingsForApp(2);
          } else if (appCode === "md") {
            props.getWhiteLabelSettingsForApp(3);
          } else if (appCode === "pt") {
            props.getWhiteLabelSettingsForApp(4);
          } else if (appCode === "bh") {
            props.getWhiteLabelSettingsForApp(5);
          } else if (appCode === "br") {
            props.getWhiteLabelSettingsForApp(6);
          } else if (appCode === "at") {
            props.getWhiteLabelSettingsForApp(7);
          } else if (appCode === "kw") {
            props.getWhiteLabelSettingsForApp(8);
          } else if (appCode === "tr") {
            props.getWhiteLabelSettingsForApp(9);
          } else if (appCode === "ss") {
            props.getWhiteLabelSettingsForApp(10);
          } else if (appCode === "ss") {
            props.getWhiteLabelSettingsForApp(10);
          } else if (appCode === "rt") {
            props.getWhiteLabelSettingsForApp(11);
          } else if (appCode === "mm") {
            props.getWhiteLabelSettingsForApp(12);
          }
        } catch (ex) {}
      }

      if (props.match.params.token !== null) {
        UserService()
          .validateToken(props.match.params.token)
          .then((resp) => {
            if (resp.msg !== "ok") {
              let link = `/token-invalid/${resp.msg}`;
              props.history.push(link);
            }
          })
          .catch((err) => {
            props.history.push("/token-invalid");
          });
      }
    }, [2000]);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {loading && <Loader show={loading} message={"Loading..."} />}
      {!loading && (
        <div>
          <div
            style={{
              border: "solid 1px grey",
              padding: 30,
              borderRadius: 10,
              margin: 30,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {props.whiteLabelSettings.isWhiteLabel && (
                <img
                  alt={" Logo"}
                  src={props.whiteLabelSettings.logoUrl}
                  style={{
                    maxHeight: "150px",
                    maxWidth: "275px",
                    borderRadius: 10,
                    overflow: "hidden",
                    backgroundColor: "white",
                  }}
                />
              )}
              {!props.whiteLabelSettings.isWhiteLabel && (
                <img src={acHealthLogo} width="40%" />
              )}
              <h2
                style={{
                  color: props.whiteLabelSettings.isWhiteLabel
                    ? props.whiteLabelSettings.primaryColor
                    : colorsV2.main,
                }}
              >
                Password Rules
              </h2>
              <ul>
                <li style={{ color: length ? "green" : null }}>
                  At least 8 characters long
                </li>
                <li style={{ color: lower ? "green" : null }}>
                  At least 1 lower case letter (a-z)
                </li>
                <li style={{ color: upper ? "green" : null }}>
                  At least 1 UPPER CASE letter (A-Z)
                </li>
                <li style={{ color: number ? "green" : null }}>
                  At least 1 number (0-9)
                </li>
                <li style={{ color: special ? "green" : null }}>
                  At least 1 special character (!@#$%^&*)
                </li>
                <li style={{ color: repeat ? "green" : null }}>
                  No more than 2 identical characters in a row (e.g., "aaa" is
                  not allowed)
                </li>
                <li style={{ color: match ? "green" : null }}>
                  Password and Confirm Password values must match
                </li>
              </ul>
              <TextField
                variant="outlined"
                label="Password"
                required
                fullWidth
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                type="password"
                style={{ marginBottom: 10 }}
              />
              <TextField
                variant="outlined"
                label="Confirm Password"
                required
                fullWidth
                value={confirmPassword}
                onChange={(event) => setConfirmPassword(event.target.value)}
                type="password"
                style={{ marginBottom: 10 }}
              />
              {error && <p style={{ color: "red" }}>{error}</p>}
              <div
                style={{
                  marginTop: 20,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  type="primary"
                  variant="contained"
                  onClick={() => submit()}
                  style={{
                    backgroundColor: buttonDisabled
                      ? "grey"
                      : props.whiteLabelSettings.isWhiteLabel
                      ? props.whiteLabelSettings.accentColor
                      : colorsV2.lightningYellow,
                    color: "white",
                  }}
                  disabled={buttonDisabled}
                >
                  Reset Password
                </Button>
              </div>
            </div>
          </div>
          <Dialog open={showSuccess}>
            <DialogContent>
              <DialogContentText
                id="alert-dialog-description"
                style={{ paddingBottom: 20 }}
              >
                <h1 style={{ fontWeight: 600 }}>Password Updated</h1>
                Your password was successfully changed. You may use your updated
                password to login to the portal or mobile application. You will
                be redirected to the login page momentarily.
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </div>
      )}
    </div>
  );
};

function mapStateToProps({ whiteLabelSettings }) {
  return {
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordReset);



// WEBPACK FOOTER //
// ./src/layout/PasswordReset/PasswordReset.js